import { AddOutlined } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";
import dayjs from "dayjs";
import {
    ListDetailItemList,
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
    ListViewItem,
} from "../../components/ListDetailView";
import { useUserInfo } from "../../utils/security";
import { EstimatesSimpleFilter } from "./EstimatesSimpleFilter";
import { EstimatesAdvancedFilter } from "./EstimateslAdvancedFilter";

const EstimateListItem = ({ data, _onClick, dateFormat, ...props }) => {
    return (
        <ListViewItem
            {...props}
            mainText={data.name}
            secondaryText={[data.clientName]}
            mainValue={<Chip label="success" color="success" size="small" />}
            secondaryValue={dayjs(data.stateChanged).format(dateFormat)}
        />
    );
};

export const EstimatesList = ({
    overviewState,
    compact,
    loading,
    onAddEstimate,
    data,
    selectItem,
    detailId,
    setFilter,
    filter,
    filterVisible,
    setFilterVisible,
    onShowRecurringDialog,
}) => {
    const { userInfo } = useUserInfo();
    console.log(detailId);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Kalkulace"
                role="list"
                loading={loading}
                compact={compact}
                actions={[
                    {
                        title: "Přidat ...",
                        icon: <AddOutlined />,
                        items: (userInfo?.employeeTypes || []).map((employeeType) => ({
                            title: employeeType.name,
                            icon: <AddOutlined />,
                            onClick: () => onAddEstimate?.(employeeType),
                        })),
                    },
                ]}>
                <EstimatesSimpleFilter />
            </ListDetailViewSectionHeader>
            <ListDetailViewSectionContent>
                <Box px={2}>
                    <EstimatesAdvancedFilter />
                    {/*
                    {compact === true && (
                        <EstimatesOverviewContent
                            data={overviewState?.data}
                            loading={overviewState?.loading}
                        />
                    )}
                        */}
                </Box>
                <ListDetailItemList
                    data={data}
                    loading={loading}
                    renderItem={(props) => (
                        <EstimateListItem {...props} dateFormat={userInfo.dateFormat} />
                    )}
                    compact={compact}
                    detailId={detailId}
                    selectItem={selectItem}
                />
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
